import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ahrefs/sync_lists/index.vue') }

  static values = {
    canExecute: Boolean
  }

  connect() {
    super.connect({
      canExecute: this.canExecuteValue
    })
  }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ahrefs/sync_lists/show.vue') }

  static values = {
    syncListId: String,
    canExecute: Boolean
  }

  connect() {
    super.connect({
      syncListId: this.syncListIdValue,
      canExecute: this.canExecuteValue
    })
  }
}

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ahrefs/sync_lists/new.vue') }
}
